module.exports = require("@swa-ui/core/src/LoadingDepiction/LoadingDepiction.module.scss");